module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-react-router-scroll/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 398
// module chunks = 168707334958949